<template>
  <div class="animated fadeInRight ecommerce">
    <el-row>
      <el-col :span="24">
        <el-card>
          <div slot="header" class="flex justify-between">
            <span>{{ $t('serviceManage.queryCondition') }}</span>
          </div>
          <el-form :inline="true" :model="serviceManageInfo.conditions" class="flex justify-start">
            <el-form-item>
              <el-input v-model="serviceManageInfo.conditions.serviceName"
                :placeholder="$t('serviceManage.enterServiceName')" clearable>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="serviceManageInfo.conditions.serviceCode"
                :placeholder="$t('serviceManage.enterServiceCode')" clearable>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="serviceManageInfo.conditions.serviceUrl"
                :placeholder="$t('serviceManage.enterServiceUrl')" clearable>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="_queryServiceMethod" icon="el-icon-search">
                {{ $t('serviceManage.query') }}
              </el-button>
              <el-button @click="_resetServiceMethod" icon="el-icon-refresh">
                {{ $t('serviceManage.reset') }}
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-card>
          <div slot="header" class="flex justify-between">
            <span>{{ $t('serviceManage.serviceInfo') }}</span>
            <div class="">
              <el-button type="primary" size="small" icon="el-icon-plus" @click="_openAddServiceModal">
                {{ $t('serviceManage.addService') }}
              </el-button>
            </div>
          </div>

          <el-table :data="serviceManageInfo.services" border style="width: 100%">
            <el-table-column prop="serviceId" :label="$t('serviceManage.serviceId')" align="center">
            </el-table-column>
            <el-table-column prop="name" :label="$t('serviceManage.serviceName')" align="center">
            </el-table-column>
            <el-table-column prop="serviceCode" :label="$t('serviceManage.serviceCode')" align="center">
            </el-table-column>
            <el-table-column prop="url" :label="$t('serviceManage.serviceUrl')" align="center">
            </el-table-column>
            <el-table-column prop="method" :label="$t('serviceManage.serviceMethod')" align="center">
            </el-table-column>
            <el-table-column :label="$t('serviceManage.operation')" align="center">
              <template slot-scope="scope">
                <el-button size="mini" @click="_openEditServiceModel(scope.row)">
                  {{ $t('serviceManage.edit') }}
                </el-button>
                <el-button size="mini" type="danger" @click="_openDeleteServiceModel(scope.row)">
                  {{ $t('serviceManage.delete') }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
            layout="total, prev, pager, next, jumper" :total="serviceManageInfo.total">
          </el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <add-service ref="addService" @success="queryService"></add-service>
    <edit-service ref="editService" @success="queryService"></edit-service>
    <delete-service ref="deleteService" @success="queryService"></delete-service>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { listServices, getAppInfo } from '@/api/dev/serviceManage/serviceManageApi'
import AddService from '@/components/dev/addService/addService'
import EditService from '@/components/dev/editService/editService'
import DeleteService from '@/components/dev/deleteService/deleteService'

export default {
  name: 'ServiceManage',
  components: {
    AddService,
    EditService,
    DeleteService
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      serviceManageInfo: {
        services: [],
        total: 0,
        conditions: {
          serviceName: '',
          serviceCode: '',
          serviceUrl: ''
        }
      }
    }
  },
  created() {
    this._loadDataByParam()
  },
  methods: {
    queryService() {
      this._listServices(this.currentPage, this.pageSize)
    },
    async _listServices(page, rows) {
      try {
        const params = {
          page: page,
          row: rows,
          ...this.serviceManageInfo.conditions
        }
        const res = await listServices(params)
        this.serviceManageInfo.services = res.data
        this.serviceManageInfo.total = res.total
        this.serviceManageInfo.records = res.records
        console.log(this.serviceManageInfo.records)
      } catch (error) {
        console.error('获取服务列表失败:', error)
      }
    },
    _openAddServiceModal() {
      this.$refs.addService.open()
    },
    _openEditServiceModel(service) {
      this.$refs.editService.open(service)
    },
    _openDeleteServiceModel(service) {
      this.$refs.deleteService.open(service)
    },
    _queryServiceMethod() {
      this._listServices(this.currentPage, this.pageSize)
    },
    _resetServiceMethod() {
      this.serviceManageInfo.conditions = {
        serviceName: '',
        serviceCode: '',
        serviceUrl: ''
      }
      this._listServices(this.currentPage, this.pageSize)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._listServices(val, this.pageSize)
    },
    async _loadDataByParam() {
      this.serviceManageInfo.conditions.appId = this.$route.query.appId
      if (!this.serviceManageInfo.conditions.appId) {
        this._listServices(this.currentPage, this.pageSize)
        return
      }

      try {
        const shopId = getShopId()
        const res = await getAppInfo({
          shopId: shopId,
          appId: this.serviceManageInfo.conditions.appId
        })
        this.serviceManageInfo.conditions.appName = res.name
      } catch (error) {
        console.error('获取应用信息失败:', error)
      }

      this._listServices(this.currentPage, this.pageSize)
    }
  }
}
</script>

<style scoped>
.el-row {
  width: 100%;
  margin-bottom: 20px;
}

.el-col {
  width: 100%;
}

.card-header-right {
  float: right;
}
</style>